import EmblaCarousel from "https://cdn.jsdelivr.net/npm/embla-carousel@8.6.0/+esm";
import EmblaCarouselFade from "https://cdn.jsdelivr.net/npm/embla-carousel-fade@8.6.0/+esm";
import EmblaCarouselAutoplay from "https://cdn.jsdelivr.net/npm/embla-carousel-autoplay@8.6.0/+esm";

class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.emblaNode = this.querySelector("[data-embla-carousel]");
    this.viewportNode = this.querySelector(".review-slider__viewport");
    this.prevBtn = this.querySelector(".review-slider__button--prev");
    this.nextBtn = this.querySelector(".review-slider__button--next");
  }

  connectedCallback() {
    this.initCarousel();
  }

  async initCarousel() {
    // Initialize carousel with fade plugin
    this.embla = EmblaCarousel(
      this.viewportNode,
      {
        loop: true,
        // duration: 60,
      },
      [EmblaCarouselFade(), EmblaCarouselAutoplay({ delay: 6000 })]
    );

    // Setup button listeners
    this.prevBtn.addEventListener("click", () => this.embla.scrollPrev());
    this.nextBtn.addEventListener("click", () => this.embla.scrollNext());

    // Update button states
    this.embla.on("select", () => this.updateButtonStates());
    this.updateButtonStates();
  }

  updateButtonStates() {
    if (!this.embla) return;

    this.prevBtn.disabled = !this.embla.canScrollPrev();
    this.nextBtn.disabled = !this.embla.canScrollNext();
  }
}

customElements.define("review-slider", ReviewSlider);
